import { useMount } from 'ahooks';
import {
  reportPageLog,
  reportButtonLog as reportButtonLogDBI,
  reportSearchLog as reportSearchLogDBI,
} from '@intelligence/v3/utils/logReporter';
import { dbuPageLogMes, dbuBtnLogMes, dbuSearchLogMes } from '@user-center/_config/buriedPoint';

import type { IDetailsPagePointConfig } from '@intelligence/v3/utils/logReporter';

export const reportButtonLog = (btnLogKey: string, dynamicParams?: any) => {
  const params = dbuBtnLogMes[btnLogKey];
  return reportButtonLogDBI({ ...params, ...dynamicParams });
};

export const reportSearchLog = (searchLogKey: any, dynamicParams?: any) => {
  const params = dbuSearchLogMes[searchLogKey];
  return reportSearchLogDBI({ ...params }, dynamicParams);
};

/**
 * 页面打点
 * @param pageLogKey 页面打点配置键
 * @param idConfig 页面打点配置中的id相关配置，比如uidType和uid
 */
export default function usePageLog(pageLogKey: string, idConfig?: IDetailsPagePointConfig) {
  useMount(() => {
    const logParams = dbuPageLogMes[pageLogKey];
    reportPageLog({ ...logParams, ...idConfig });
  });
}

export { reportPageLog };
